/* @flow weak */
const defaults = {
  width: 500,
  height: 400,
  menubar: 0,
  scrollbars: 0,
  location: 0,
  left() {
    return window.screen.width / 2 - this.width / 2;
  },
  top() {
    return window.screen.height / 2 - this.height / 2;
  },
};

function openPopup(url, name, options = {}) {
  const buildParams = function(obj) {
    return Object.keys(obj)
      .map(key => {
        const val = typeof obj[key] === 'function' ? obj[key].call(obj) : obj[key];
        return `${key}=${val}`;
      })
      .join(',');
  };

  const defaultedOptions = Object.assign({}, defaults, options);
  return window.open(url, name, buildParams(defaultedOptions));
}

export default openPopup;
